/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationChatSettingResponseData,
  GetOrganizationChatSettingResponseDataFromJSON,
  GetOrganizationChatSettingResponseDataFromJSONTyped,
  GetOrganizationChatSettingResponseDataToJSON
} from './GetOrganizationChatSettingResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationChatSettingChatButtonImageResponse
 */
export interface UpdateOrganizationChatSettingChatButtonImageResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationChatSettingChatButtonImageResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationChatSettingResponseData}
   * @memberof UpdateOrganizationChatSettingChatButtonImageResponse
   */
  data?: GetOrganizationChatSettingResponseData
}

export function UpdateOrganizationChatSettingChatButtonImageResponseFromJSON(
  json: any
): UpdateOrganizationChatSettingChatButtonImageResponse {
  return UpdateOrganizationChatSettingChatButtonImageResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationChatSettingChatButtonImageResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationChatSettingChatButtonImageResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationChatSettingResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationChatSettingChatButtonImageResponseToJSON(
  value?: UpdateOrganizationChatSettingChatButtonImageResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationChatSettingResponseDataToJSON(value.data)
  }
}
